"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ha1Compute = void 0;
var md5_1 = __importDefault(require("md5"));
function ha1Compute(algorithm, user, realm, pass, nonce, cnonce) {
    var ha1 = md5_1.default(user + ":" + realm + ":" + pass);
    if (algorithm && algorithm.toLowerCase() === "md5-sess") {
        return md5_1.default(ha1 + ":" + nonce + ":" + cnonce);
    }
    return ha1;
}
exports.ha1Compute = ha1Compute;
